<h1 mat-dialog-title fxLayoutAlign="center">{{ (data.title ?? 'error') | transloco }}</h1>
<div mat-dialog-content>
  {{ data.info }}
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button type="button" [cdkCopyToClipboard]="data.info">{{ 'copy_info' | transloco }}</button>
  <button mat-flat-button type="button" color="primary" (click)="close()">{{ 'close' | transloco }}</button>
</div>